(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-exhale-newsletter"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-exhale-newsletter-form')) {
		class LTAExhaleNewsletterForm extends HTMLElement {
			constructor() {
				super()
				this._onSubmit = this._onSubmit.bind(this)
			}

			connectedCallback() {
				this.form = this.querySelector('form')
				this.emailInput = this.querySelector('[data-email]')
				this.submitButton = this.querySelector('[type="submit"]')
				this.statusEl = this.querySelector('[data-status]')
				if (!this.form || !this.emailInput || !this.submitButton) return

				this.form.addEventListener('submit', this._onSubmit)
			}

			disconnectedCallback() {
				if (this.form) this.form.removeEventListener('submit', this._onSubmit)
			}

			_setStatus(message) {
				if (this.statusEl) this.statusEl.textContent = message || ''
			}

			_setLoading(isLoading) {
				this.submitButton.classList.toggle('l-button-loading', isLoading)
				this.submitButton.disabled = isLoading
			}

			async _onSubmit(event) {
				event.preventDefault()
				this._setStatus('')

				const companyId = this.dataset.companyId
				const listId = this.dataset.listId
				if (!companyId || !listId) {
					this._setStatus(this.dataset.configErrorMessage || '')
					return
				}

				const email = this.emailInput.value.trim()
				if (!email || !this.emailInput.checkValidity()) {
					this.emailInput.reportValidity()
					return
				}

				this._setLoading(true)

				try {
					const response = await fetch(
						`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`,
						{
							method: 'POST',
							headers: {
								revision: '2024-10-15',
								'Content-Type': 'application/json',
								Accept: 'application/json',
							},
							body: JSON.stringify({
								data: {
									type: 'subscription',
									attributes: {
										profile: {
											data: {
												type: 'profile',
												attributes: {
													email: email,
												},
											},
										},
									},
									relationships: {
										list: {
											data: {
												type: 'list',
												id: listId,
											},
										},
									},
								},
							}),
						}
					)

					if (!response.ok && response.status !== 202) {
						throw new Error(String(response.status))
					}

					this.toggleAttribute('data-submitted', true)
					this._setStatus('')
				} catch (error) {
					this._setStatus(this.dataset.errorMessage || '')
				} finally {
					this._setLoading(false)
				}
			}
		}

		customElements.define('l-exhale-newsletter-form', LTAExhaleNewsletterForm)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-featured-products"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-featured-products-tabs')) {
		class LTAFeaturedProductsTabs extends HTMLElement {
			constructor() {
				super()
				this._onTabClick = this._onTabClick.bind(this)
				this._onTabKeydown = this._onTabKeydown.bind(this)
				this._onBlockSelect = this._onBlockSelect.bind(this)
				this._cleanups = []
			}

			connectedCallback() {
				this.triggerEls = this.querySelectorAll('[data-trigger]')
				this.panelEls = this.querySelectorAll('[data-content]')
				if (this.triggerEls.length < 2) return

				this.triggerEls.forEach((triggerEl) => {
					triggerEl.addEventListener('click', this._onTabClick)
					triggerEl.addEventListener('keydown', this._onTabKeydown)
					this._cleanups.push(() => {
						triggerEl.removeEventListener('click', this._onTabClick)
						triggerEl.removeEventListener('keydown', this._onTabKeydown)
					})
				})

				if (window.Shopify?.designMode) {
					document.addEventListener('shopify:block:select', this._onBlockSelect)
					this._cleanups.push(() => document.removeEventListener('shopify:block:select', this._onBlockSelect))
				}
			}

			disconnectedCallback() {
				this._cleanups.forEach((fn) => {
					try {
						fn()
					} catch {}
				})
				this._cleanups = []
			}

			_onTabClick(event) {
				this._activateTab(event.currentTarget)
			}

			_onTabKeydown(event) {
				const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End']
				if (!keys.includes(event.key)) return

				event.preventDefault()

				const triggers = Array.from(this.triggerEls)
				const currentIndex = triggers.indexOf(event.currentTarget)
				if (currentIndex < 0) return

				let nextIndex = currentIndex

				if (event.key === 'ArrowRight') {
					nextIndex = (currentIndex + 1) % triggers.length
				} else if (event.key === 'ArrowLeft') {
					nextIndex = (currentIndex - 1 + triggers.length) % triggers.length
				} else if (event.key === 'Home') {
					nextIndex = 0
				} else if (event.key === 'End') {
					nextIndex = triggers.length - 1
				}

				const nextTrigger = triggers[nextIndex]
				this._activateTab(nextTrigger)
				nextTrigger.focus()
			}

			_onBlockSelect(event) {
				if (!this.contains(event.target)) return

				const triggerEl = event.target.matches('[data-trigger]') ? event.target : event.target.closest('[data-trigger]')

				if (!triggerEl || !this.contains(triggerEl)) return
				this._activateTab(triggerEl)
			}

			_activateTab(triggerEl) {
				const panelId = triggerEl.getAttribute('data-trigger')
				if (!panelId) return

				this.triggerEls.forEach((el) => {
					const isActive = el === triggerEl
					el.classList.toggle('is-active', isActive)
					el.setAttribute('aria-selected', isActive ? 'true' : 'false')
					el.setAttribute('tabindex', isActive ? '0' : '-1')
				})

				this.panelEls.forEach((panelEl) => {
					const isActive = panelEl.getAttribute('data-content') === panelId
					panelEl.classList.toggle('l-hidden', !isActive)
					if (isActive) {
						panelEl.removeAttribute('hidden')
						panelEl.querySelector('l-swiper-carousel')?.swiperCarousel?.update?.()
					} else {
						panelEl.setAttribute('hidden', '')
					}
				})
			}
		}

		customElements.define('l-featured-products-tabs', LTAFeaturedProductsTabs)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-hub-sticky-cta"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-sticky-cta')) {
		class LTAStickyCta extends HTMLElement {
			constructor() {
				super()
				this._onScroll = this._onScroll.bind(this)
				this._ticking = false
			}

			connectedCallback() {
				if (window.Shopify?.designMode) {
					this.toggleAttribute('data-visible', true)
					this.removeAttribute('inert')
					return
				}

				this._updateVisibility()
				window.addEventListener('scroll', this._onScroll, { passive: true })
				window.addEventListener('resize', this._onScroll, { passive: true })
			}

			disconnectedCallback() {
				window.removeEventListener('scroll', this._onScroll)
				window.removeEventListener('resize', this._onScroll)
			}

			_onScroll() {
				if (this._ticking) return
				this._ticking = true
				requestAnimationFrame(() => {
					this._updateVisibility()
					this._ticking = false
				})
			}

			_updateVisibility() {
				const visible =
					window.scrollY >= document.documentElement.scrollHeight * ((Number(this.dataset.threshold) || 30) / 100)

				this.toggleAttribute('data-visible', visible)
				this.toggleAttribute('inert', !visible)
			}
		}

		customElements.define('l-sticky-cta', LTAStickyCta)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-main-product"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-product-info')) {
		customElements.define(
			'l-product-info',
			class LProductInfo extends HTMLElement {
				quantityInput = undefined
				quantityForm = undefined
				abortController = undefined
				pendingRequestUrl = null
				preProcessHtmlCallbacks = []
				postProcessHtmlCallbacks = []

				constructor() {
					super()
				}

				connectedCallback() {
					this.productFormEl = this.querySelector('l-product-form')
					this.initializeProductSwapUtility()
					this.selectedSellingPlanId =
						this.dataset.sellingPlanId ||
						new URLSearchParams(window.location.search).get('selling_plan') ||
						''
					this.productId = this.dataset.productId

					this.dispatchEvent(new CustomEvent('l:product-info:loaded', { bubbles: true }))
					this.setupEventListeners()
				}

				// Option, selling plan, and cart qty all refetch this section so price / ATC / pickers stay in sync.
				setupEventListeners() {
					document.addEventListener('l:variant:option-changed', (event) => {
						const { target, selectedOptionValues, productId, sectionId, focusTargetId } = event.detail

						if (!this.contains(target) || productId !== this.productId || sectionId !== this.sectionId) return

						this.handleOptionValueChange(target, selectedOptionValues, null, focusTargetId)
					})

					document.addEventListener('l:sellingPlan:changed', (event) => {
						const { sellingPlanId, productId, sectionId, target } = event.detail

						if (!this.contains(target) || productId !== this.productId || sectionId !== this.sectionId) return

						const variant = this.getSelectedVariant(this)

						this.selectedSellingPlanId = sellingPlanId
						this.handleOptionValueChange(event.target, null, variant)
					})

					document.addEventListener('l:product:added', (event) => {
						const { response: addedVariant } = event.detail
						const currentVariant = this.getSelectedVariant(this)

						if (addedVariant?.id == currentVariant?.id) {
							this.handleOptionValueChange(null, null, currentVariant)
						}
					})

					document.addEventListener('l:cart:closed', (event) => {
						const { updatedVariants } = event.detail
						const variant = this.getSelectedVariant(this)

						if (updatedVariants.includes(`${variant?.id}`)) this.handleOptionValueChange(null, null, variant)
					})
				}

				addPreProcessCallback(callback) {
					this.preProcessHtmlCallbacks.push(callback)
				}

				initializeProductSwapUtility() {
					this.postProcessHtmlCallbacks.push((newNode) => {
						window?.Shopify?.PaymentButton?.init()
						window?.ProductModel?.loadShopifyXR()
					})
				}

				// Complementary products change `productUrl` → swap the host; same product → patch pickers + sections.
				handleOptionValueChange(target, selectedOptionValues, variant, focusTargetId) {
					this.resetProductFormState()

					const productUrl = target?.dataset?.productUrl || this.pendingRequestUrl || this.dataset.url
					this.pendingRequestUrl = productUrl
					const shouldSwapProduct = this.dataset.url !== productUrl
					const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct

					this.renderProductInfo({
						requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, variant, shouldFetchFullPage),
						targetId: focusTargetId || target?.id,
						callback: shouldSwapProduct
							? this.handleSwapProduct(productUrl, shouldFetchFullPage)
							: this.handleUpdateProductInfo(productUrl),
					})
				}

				resetProductFormState() {
					if (this.productFormEl) {
						this.productFormEl.global_toggleSubmitButton(true, null, false)
						this.productFormEl.handleErrorMessage()
					}
				}

				renderProductInfo({ requestUrl, targetId, callback }) {
					this.abortController?.abort()
					this.abortController = new AbortController()

					fetch(requestUrl, { signal: this.abortController.signal })
						.then((response) => response.text())
						.then((responseText) => {
							this.pendingRequestUrl = null

							const html = new DOMParser().parseFromString(responseText, 'text/html')

							callback(html)
						})
						.then(() => {
							if (!targetId) return

							document.getElementById(targetId)?.focus()
						})
						.catch((error) => {
							if (error.name !== 'AbortError') {
								console.error('Product info fetch error:', error)
							}
						})
				}

				handleSwapProduct(productUrl, updateFullPage) {
					return (html) => {
						const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info'
						const variant = this.getSelectedVariant(html.querySelector(selector))

						this.updateURL(productUrl, variant?.id)

						if (updateFullPage) {
							document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML

							l_swapHtmlNode(
								document.querySelector('main'),
								html.querySelector('main'),
								this.preProcessHtmlCallbacks,
								this.postProcessHtmlCallbacks
							)
						} else {
							l_swapHtmlNode(
								this,
								html.querySelector('l-product-info'),
								this.preProcessHtmlCallbacks,
								this.postProcessHtmlCallbacks
							)
						}
					}
				}

				handleUpdateProductInfo(productUrl) {
					return (html) => {
						const variant = this.getSelectedVariant(html)

						this.updateOptionValues(html)
						this.updateSelectedVariantJson(html, variant)
						this.updateURL(productUrl, variant?.id)
						this.updateVariantInputs(variant?.id)

						if (!variant) {
							document.dispatchEvent(
								new CustomEvent('l:variant:changed', {
									detail: { sectionId: this.sectionId, html, productId: this.dataset.productId, variant },
								})
							)

							return
						}

						this.updateProductSections(html)

						document.dispatchEvent(
							new CustomEvent('l:variant:changed', {
								detail: { sectionId: this.sectionId, html, productId: this.dataset.productId, variant },
							})
						)
					}
				}

				updateSelectedVariantJson(html, variant) {
					const destination = this.querySelector('[data-product-selected-variant]')
					if (!destination) return

					const source = html.querySelector('[data-product-selected-variant]')

					if (source?.textContent) {
						destination.textContent = source.textContent
						return
					}

					if (variant) destination.textContent = JSON.stringify(variant)
				}

				updateProductSections(html) {
					const updateSourceFromDestination = (id, htmlMethod = 'innerHTML', shouldHide = () => false) => {
						const source = html.getElementById(`${id}-${this.sectionId}`)
						const destination = document.getElementById(`${id}-${this.dataset.section}`)

						if (source && destination) {
							destination[htmlMethod] = source[htmlMethod]
							destination.classList.toggle('l-hidden', shouldHide(source))
						}
					}

					updateSourceFromDestination('stockInfo', 'outerHTML')
					updateSourceFromDestination('stickyATC', 'outerHTML')
				}

				updateOptionValues(html) {
					const variantSelects = html.querySelector('l-variant-selects')

					if (variantSelects) {
						l_swapHtmlNode(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks)
					}
				}

				updateURL(url, variantId) {
					if (this.dataset.updateUrl === 'false') return

					const currentUrlParams = new URLSearchParams(window.location.search)
					const params = new URLSearchParams()

					if (variantId) params.append('variant', variantId)

					if (this.selectedSellingPlanId) params.append('selling_plan', this.selectedSellingPlanId)

					const viewTemplate = currentUrlParams.get('view')

					if (viewTemplate) params.append('view', viewTemplate)

					const newUrl = `${url}${params.size > 0 ? '?' : ''}${params.toString()}`

					window.history.replaceState({}, '', newUrl)
				}

				updateVariantInputs(variantId) {
					if (variantId == null || variantId === '') return

					this.querySelectorAll(`#product-form-${this.dataset.section}`).forEach((productForm) => {
						const input = productForm.querySelector('input[name="id"]')

						input.value = variantId
						input.dispatchEvent(new Event('change', { bubbles: true }))
					})
				}

				getSelectedVariant(productInfoNode) {
					const root = productInfoNode || this
					const selectedVariantEl = root.querySelector(
						'[data-product-selected-variant], l-variant-selects [data-selected-variant], [data-selected-variant]'
					)
					const selectedVariantHtml = selectedVariantEl?.innerHTML?.trim()

					if (selectedVariantHtml) {
						try {
							return JSON.parse(selectedVariantHtml)
						} catch (error) {
							console.error('Failed to parse selected variant JSON:', error)
						}
					}

					const variantId = root.querySelector('input[name="id"]')?.value

					return variantId ? { id: Number(variantId) } : null
				}

				buildRequestUrlWithParams(url, optionValues, variant, shouldFetchFullPage = false) {
					const params = []

					if (!shouldFetchFullPage) {
						params.push(`section_id=${this.sectionId}`)
					}

					if (this.selectedSellingPlanId) {
						params.push(`selling_plan=${this.selectedSellingPlanId}`)
					}

					if (optionValues?.length) {
						params.push(`option_values=${optionValues.join(',')}`)
					} else if (variant) {
						params.push(`variant=${variant.id}`)
					}

					return `${url}?${params.join('&')}`
				}

				get productForm() {
					return this.querySelector('l-product-form')
				}

				get variantSelectors() {
					return this.querySelector('l-variant-selects')
				}

				get sectionId() {
					return this.dataset.originalSection || this.dataset.section
				}
			}
		)
	}

	if (!customElements.get('l-product-media-gallery')) {
		customElements.define(
			'l-product-media-gallery',
			class LTAProductMediaGallery extends HTMLElement {
				constructor() {
					super()

					this._onVariantChange = this._onVariantChange.bind(this)
					this._onCarouselLoaded = this._onCarouselLoaded.bind(this)
					this._onSlideChange = this._onSlideChange.bind(this)
					this._onThumbClick = this._onThumbClick.bind(this)
				}

				connectedCallback() {
					this._abort = new AbortController()
					const { signal } = this._abort

					this.carouselEl = this.querySelector('[data-main-carousel]')
					this.thumbsEl = this.querySelector('[data-thumbs-carousel]')

					document.addEventListener('l:variant:changed', this._onVariantChange, { signal })
					this.addEventListener('l:swiper:carousel:loaded', this._onCarouselLoaded, { signal })
					this.addEventListener('l:product-model:loaded', this._onSlideChange, { signal })
					this.addEventListener('click', this._onThumbClick, { signal })

					if (this.carouselEl?.swiperCarousel) this._bindSwiper()
				}

				disconnectedCallback() {
					this._abort?.abort()
					this._thumbsSwiper?.destroy?.(true, true)
					this._thumbsSwiper = null
				}

				get swiper() {
					return this.carouselEl?.swiperCarousel
				}

				_onCarouselLoaded() {
					this._thumbsSwiper?.destroy?.(true, true)
					this._thumbsSwiper = null
					this._bindSwiper()
				}

				_bindSwiper() {
					const swiper = this.swiper

					if (!swiper) return

					if (!this._swiperBound) {
						this._swiperBound = true
						swiper.on('slideChange', this._onSlideChange)
					}

					this._initThumbs()
					this._onSlideChange()
				}

				_initThumbs() {
					const configNode = this.thumbsEl?.querySelector('[data-thumbs-config]')

					if (!this.thumbsEl || !configNode || !this.swiper || this._thumbsSwiper || !window.Swiper) return

					this._thumbsSwiper = new window.Swiper(this.thumbsEl, JSON.parse(configNode.textContent))
					this.swiper.params.thumbs ||= {}
					this.swiper.params.thumbs.swiper = this._thumbsSwiper
					this.swiper.thumbs?.init()
					this.swiper.thumbs?.update(true)
				}

				_onThumbClick(event) {
					const btnEl = event.target.closest('[data-thumb-btn]')

					if (!btnEl) return

					const index = [...this.querySelectorAll('[data-thumb]')].indexOf(btnEl.closest('[data-thumb]'))

					if (index >= 0) this.swiper?.slideTo(index)
				}

				_onSlideChange() {
					const swiper = this.swiper

					if (!swiper) return

					const activeEl = swiper.slides[swiper.activeIndex]
					const index = swiper.activeIndex

					this.carouselEl.querySelectorAll('[data-media]').forEach((slideEl) => {
						if (slideEl === activeEl) return

						l_pauseAllMedia(slideEl)
						slideEl.querySelector('l-media-video')?.pauseVideo()
					})

					this.querySelectorAll('[data-thumb]').forEach((thumbEl, thumbIndex) => {
						const active = thumbIndex === index

						thumbEl.toggleAttribute('data-active', active)
						thumbEl.querySelector('[data-thumb-btn]')?.toggleAttribute('aria-current', active)
					})

					swiper.allowTouchMove = !activeEl?.querySelector('l-product-model[data-loaded]')
				}

				_mediaIndex(mediaId) {
					return [...this.carouselEl.querySelectorAll('[data-media]')].findIndex(
						(slideEl) => slideEl.dataset.mediaId == `${mediaId}`
					)
				}

				_onVariantChange({ detail }) {
					const { sectionId, productId, variant } = detail || {}

					if (
						productId !== this.dataset.productId ||
						sectionId !== this.dataset.sectionId ||
						!variant?.featured_media?.id
					)
						return

					const index = this._mediaIndex(variant.featured_media.id)

					if (index >= 0) this.swiper?.slideTo(index)
				}
			}
		)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-pdp-recommendations"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-product-recommendations')) {
		class LTAProductRecommendations extends HTMLElement {
			connectedCallback() {
				this._onSectionLoad = this._onSectionLoad.bind(this)
				this._sectionEl = this.closest('[id^="shopify-section-"]')

				if (window.Shopify?.designMode) {
					document.addEventListener('shopify:section:load', this._onSectionLoad)
					this._loadRecommendations()
					return
				}

				this._loadRecommendations()
			}

			disconnectedCallback() {
				document.removeEventListener('shopify:section:load', this._onSectionLoad)
			}

			_onSectionLoad(event) {
				if (event.target.contains(this)) this._loadRecommendations()
			}

			_loadRecommendations() {
				const url = this.dataset.url
				if (!url || this.dataset.loading === 'true' || this.dataset.loaded === 'true') return

				this.dataset.loading = 'true'

				fetch(url)
					.then((response) => {
						if (!response.ok) throw new Error(String(response.status))
						return response.text()
					})
					.then((text) => {
						const doc = new DOMParser().parseFromString(text, 'text/html')
						const incoming = doc.querySelector('l-product-recommendations')

						if (incoming?.innerHTML.trim().length) {
							this._sectionEl?.removeAttribute('hidden')
							this.innerHTML = incoming.innerHTML
							this.dataset.loaded = 'true'
							return
						}

						if (!window.Shopify?.designMode) {
							this._sectionEl?.setAttribute('hidden', '')
						}
					})
					.catch(() => {
						if (!window.Shopify?.designMode) {
							this._sectionEl?.setAttribute('hidden', '')
						}
					})
					.finally(() => {
						this.dataset.loading = 'false'
					})
			}
		}

		customElements.define('l-product-recommendations', LTAProductRecommendations)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-quick-nav"] && !Shopify.designMode) return;
  try {
    
	class QuickNavCollection extends HTMLElement {
		connectedCallback() {
			this.handleClick = this.handleClick.bind(this)
			this.addEventListener('click', this.handleClick)
		}

		disconnectedCallback() {
			this.removeEventListener('click', this.handleClick)
		}

		getCollectionSection() {
			return document.querySelector('.js-collection')
		}

		getCollectionSectionId(collectionSection) {
			const sectionWrapper = collectionSection?.closest('[id^="shopify-section-"]')
			if (!sectionWrapper?.id) return null
			return sectionWrapper.id.replace('shopify-section-', '')
		}

		getResetUrl() {
			return this.dataset.colllectionUrl || this.dataset.collectionUrl || window.location.pathname
		}

		setActiveLink(activeLink) {
			this.querySelectorAll('.l-sCQNav__link').forEach((link) => {
				link.classList.toggle('is-active', link === activeLink)
			})
		}

		async handleClick(event) {
			const link = event.target.closest('.l-sCQNav__link')
			const resetButton = event.target.closest('[data-quick-nav-reset]')
			if (!link && !resetButton) return

			const collectionSection = this.getCollectionSection()
			const sectionId = this.getCollectionSectionId(collectionSection)
			if (!collectionSection || !sectionId) return

			event.preventDefault()
			const isResetFromButton = !!resetButton
			const isResetFromActiveLink = !!link && link.classList.contains('is-active')
			const targetUrl = isResetFromButton || isResetFromActiveLink ? this.getResetUrl() : link.href
			const requestUrl = new URL(targetUrl, window.location.origin)
			requestUrl.searchParams.set('section_id', sectionId)

			try {
				const response = await fetch(requestUrl.toString(), {
					headers: { 'X-Requested-With': 'XMLHttpRequest' },
				})
				if (!response.ok) throw new Error(`Failed to fetch section: ${response.status}`)

				const html = await response.text()
				const parsed = new DOMParser().parseFromString(html, 'text/html')
				const incomingCollection = parsed.querySelector('.js-collection')

				if (incomingCollection) {
					collectionSection.replaceWith(incomingCollection)
				} else {
					collectionSection.innerHTML = parsed.body.innerHTML
				}

				if (!isResetFromButton && !isResetFromActiveLink && link) {
					this.setActiveLink(link)
				} else {
					this.setActiveLink(null)
				}

				history.pushState({}, '', targetUrl)
			} catch (error) {
				window.location.href = targetUrl
			}
		}
	}

	if (!customElements.get('quick-nav-collection')) {
		customElements.define('quick-nav-collection', QuickNavCollection)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super()
			this.elements = {
				input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
			}
			this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)))
		}

		onItemClick(event) {
			event.preventDefault()
			const form = this.querySelector('form')
			this.elements.input.value = event.currentTarget.dataset.value
			if (form) form.submit()
		}
	}

	customElements.define('localization-form', LocalizationForm)

  } catch(e) { console.error(e); }
})();
})();
